export const environment = {
  production: true,
  role: 'production',
  apiUrl: '/api',
  managementUrl: '/management',
  adessoApiUrl: '/management',
  oauth: {
    issuer: '',
    clientId: '',
    redirectUri: '',
    requireHttps: true,
    tenantOrganizationAlias: '',
    allowedRoles: ['organization_admin'],
    devBypassRole: ''
  }
};
